<template>
	<div class="page_broadcast">
		<div v-if="$route.name !== 'broadDetails'" v-loading="loading">
			<ul class="list">
				<li v-for="(v, i) in list" :key="i" @click="$router.push({ name: 'broadDetails', query: { id: v.id } })">
					<span class="title" :title="v.title">{{ v.title }}</span>
					<span class="time">{{ v.releaseTime | formatDate }}</span>
				</li>
			</ul>
			<page v-if="list.length > 0" :total="total" :currentPage="currentPage" :pageSize="pageSize" v-on:pagination="getList"></page>
		</div>
		<div class="details" v-else>
			<router-view :key="$route.fullPath"></router-view>
		</div>
	</div>
</template>

<script>
import page from '@/components/Pagination/index.vue'
import { formatdate } from '@/utils/index'
export default {
	components: {
		page,
	},
	data() {
		return {
			list: [],
			total: 0,
			currentPage: 1,
			pageSize: 10,
			loading: false,
		}
	},
	filters: {
		formatDate(time) {
			var date = new Date(time)
			return formatdate(date, 'yyyy-MM-dd hh:mm:ss') // 此处可根据自己的需要自定义想要的日期格式
		},
	},
	created() {
		this.getList({
			page: 1,
			limit: this.pageSize,
		})
	},
	methods: {
		getList(obj) {
			this.loading = true
			this.$http
				.post(this.$api.systemApi.news, {
					current: obj.page,
					size: obj.limit,
					data: {
						type: 'TZGG',
					},
				})
				.then(({ data }) => {
					this.loading = false
					this.list = data.data.list || []
					this.total = data.data.total || 0
				})
				.catch(() => {
					this.loading = false
					this.list = []
					this.total = 0
				})
		},
	},
}
</script>

<style lang="scss" scoped>
.page_broadcast {
	.list {
		li {
			display: flex;
			align-items: center;
			justify-content: space-between;
			height: 40px;
			line-height: 40px;
			padding: 0 16px;
			margin-bottom: 8px;
			background: #f7f7f7;
			border-radius: 8px;
			cursor: pointer;
			&:hover {
				opacity: 0.8;
			}
			.title {
				flex: 1;
			}
			.time {
				color: #999999;
			}
		}
	}
}

.title {
	width: 82%;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}
</style>
